import React, { useEffect, useState } from "react";
import Button from "../../components/Button";
import { useForm } from "react-hook-form";
import { handleBlur } from "../../utility/action";
import { confirmationCodeValidation } from "../../utility/Validation/validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { notify } from "../../utility/Toastify/toastify";
import poolData from "./AWSConfig/PoolData";
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import "../../styles/pages/Auth/auth.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkEmailException } from "../../utility/helper";
import PoolData from "./AWSConfig/PoolData";
import {
  setAuthData,
  setToken,
  setUserData,
} from "../../redux/main/action/main";
import axios from "axios";
import { Button as AntdButton } from "antd";
import alert from "../../components/alerts/Alert";
import { MdEmail } from "react-icons/md";
import AuthLayout from "../../components/layout/AuthLayout";

const TIMER_SEC = 30;

function ConfirmEmail({ registeredEmail }) {
  const {
    main: { userPass },
  } = useSelector((state) => state);

  const savedUserPass = localStorage.getItem("userPass")?.split(",");
  const savedEmail = savedUserPass?.[0];
  const savedPass = savedUserPass?.[1];

  //btn loading
  const [loading, setLoading] = useState(false);
  const [emailValue, setEmailValue] = useState(
    registeredEmail || savedEmail || "",
  );
  const [seconds, setSeconds] = useState(TIMER_SEC);
  const [resendLoading, setResendLoading] = useState(false);

  let navigate = useNavigate();
  const dispatch = useDispatch();

  const handleResendCode = async () => {
    if (seconds > 0 || resendLoading) return;
    setResendLoading(true);
    const getUser = () => {
      return new CognitoUser({
        Username: checkEmailException(emailValue),
        Pool: PoolData,
      });
    };

    const onSuccess = (data) => {
      setResendLoading(false);
      notify(
        "Confirmation code sent to your email inbox. Please check your email and enter the code.",
        "success",
      );
    };
    const onFailure = (err) => {
      notify(err.message || JSON.stringify(err), "error");
      setResendLoading(false);
    };

    const configData = {
      operation_mode: "resend_confirmation_code",
      email: emailValue?.toLowerCase(),
    };

    await axios
      .post(
        "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        configData,
      )
      .then((res) => {
        // console.log(res?.data);
        notify(
          "Confirmation code sent to your email inbox. Please check your email and enter the code.",
          "success",
        );
      })
      .catch((err) => {
        console.log(err);
        const { message } = err?.response?.data;

        notify(message || JSON.stringify(err), "error");
      })
      .finally(() => {
        setSeconds(TIMER_SEC);
        setResendLoading(false);
      });

    // getUser().resendConfirmationCode((err, data) => {
    //   setSeconds(TIMER_SEC);
    //   if (err) {
    //     onFailure(err);
    //   } else {
    //     onSuccess(data);
    //   }
    // });
  };

  //validation
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(confirmationCodeValidation),
  });

  //form submit function
  const onsubmit = async (data) => {
    setLoading(true);

    const configData = {
      operation_mode: "cognito_confirm_signup",
      email: data?.email?.toLowerCase(),
      confirmation_code: data?.confirmationCode,
      password: userPass[1] || savedPass,
    };

    await axios
      .post(
        "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        configData,
      )
      .then((res) => {
        // console.log(res?.data);
        const {
          // message,
          idToken: { jwtToken: token, payload: userData },
          refreshToken: { token: refreshToken },
        } = res?.data;

        dispatch(setAuthData(userData, token, refreshToken));

        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        navigate("/welcome");
      })
      .catch((err) => {
        console.log(err);
        const { message } = err?.response?.data;
        notify(message, "error");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    window.onbeforeunload = confirmExit;

    function confirmExit() {
      return "show warning";
    }
  }, []);

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(
        () => setSeconds((seconds) => seconds - 1),
        1000,
      );
      return () => clearTimeout(timer);
    }
  }, [seconds]);

  return (
    <AuthLayout>
      <div className="authContent">
        <h4 className="auth-title">Confirm your email</h4>

        <form
          className="login100-form validate-form cc-auth__form"
          onSubmit={handleSubmit(onsubmit)}
        >
          <p className="form-header">
            Check your inbox and enter the confirmation code.
          </p>

          <div className="cc-auth__field">
            <div
              className={`wrap-input100 validate-input ${
                errors.username && "border-error"
              }`}
            >
              <input
                className={`input100 has-val ${emailValue ? "has-value" : ""}`}
                type="text"
                placeholder="Email"
                {...register("email")}
                value={emailValue}
                onBlur={(e) => handleBlur(e)}
              />
            </div>
            {errors.email && (
              <span className="error-text">{errors.email.message}</span>
            )}
          </div>

          <div className="cc-auth__field">
            <div
              className={`wrap-input100 validate-input ${
                errors.confirmationCode && "border-error"
              }`}
            >
              <input
                className="input100 has-val"
                type={"text"}
                placeholder="Confirmation code"
                {...register("confirmationCode")}
                onBlur={(e) => handleBlur(e)}
              />
            </div>
            {errors.confirmationCode && (
              <span className="error-text">
                {errors.confirmationCode.message}
              </span>
            )}
          </div>

          <Button
            ButtonText={"Submit"}
            className={"signup cc-auth__primaryButton"}
            loading={loading}
          />

          <div className="spam-hint">
            <MdEmail className="icon" />
            Didn’t receive the code? Check your spam folder.
          </div>

          <AntdButton
            className="resend-button"
            type="button"
            onClick={handleResendCode}
            loading={resendLoading}
            disabled={resendLoading || seconds > 0}
          >
            Resend Code {seconds > 0 && `(${seconds}s)`}
          </AntdButton>

          <div className="cc-auth__footer">
            <Link className="txt2" to="/auth/login">
              Go to Login
            </Link>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
}

export default ConfirmEmail;
// const userData = {
//       Username: data?.email.toLowerCase(),
//       Pool: poolData,
//     };
//     const cognitoUser = new CognitoUser(userData);
//
//     return new Promise((resolve, reject) => {
//       cognitoUser.confirmRegistration(
//         data?.confirmationCode,
//         true,
//         function (err, result) {
//           if (err) {
//             notify(err?.message, "error");
//             reject(err);
//             setLoading(false);
//           } else {
//             resolve(result);
//
//             // let user = new CognitoUser({
//             //   Username: checkEmailException(userPass[0] || savedEmail),
//             //   Pool: PoolData,
//             // });
//             // let authDetails = new AuthenticationDetails({
//             //   Username: userPass[0] || savedEmail,
//             //   Password: userPass[1] || savedPass,
//             //   ValidationData: { captcha: "rtspa_mehdi_ravanbakhsh_761" },
//             // });
//
//             // user.authenticateUser(authDetails, {
//             //   onSuccess: (data) => {
//             //     dispatch(setToken(data?.idToken?.jwtToken));
//             //     dispatch(setUserData(data?.idToken?.payload));
//             //     axios.defaults.headers.common["Authorization"] =
//             //       `Bearer ${data?.idToken?.jwtToken}`;
//             //     // window.location.reload();
//             //     // notify("You have successfully logged in", "success");
//             //     localStorage.setItem(
//             //       "aws-amplify-federatedInfo",
//             //       JSON.stringify({ token: data?.idToken?.jwtToken }),
//             //     );
//             //     localStorage.setItem(
//             //       "aws-amplify-USERDATA",
//             //       JSON.stringify(data?.idToken?.payload),
//             //     );
//             //     localStorage.setItem("refreshToken", data?.refreshToken?.token);
//             //     setLoading(false);
//             //     notify("You have successfully signed up", "success");
//             //     // navigate("/ai-assistant/assistant");
//             //     // navigate("/dashboard");
//             //     navigate("/welcome");
//             //   },
//             //
//             //   onFailure: function (err) {
//             //     window.grecaptcha.reset();
//             //     setLoading(false);
//             //     if (err?.message.includes("captcha")) return;
//             //     notify(err?.message, "error");
//             //   },
//             //
//             //   newPasswordRequired: (data) => {
//             //     notify(data, "success");
//             //     setLoading(false);
//             //   },
//             // });
//             // setLoading(false);
//             // navigate("/auth/login");
//           }
//         },
//       );
//     });
//     // [{Name:"email",Value:data?.email}]
